import { render, staticRenderFns } from "./StepSuccess.vue?vue&type=template&id=89bd3d54&scoped=true&"
import script from "./StepSuccess.vue?vue&type=script&lang=js&"
export * from "./StepSuccess.vue?vue&type=script&lang=js&"
import style0 from "./StepSuccess.vue?vue&type=style&index=0&id=89bd3d54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bd3d54",
  null
  
)

export default component.exports